import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {AccountService, ChangeFiltersService, LandingService, RecipeService} from '../shared/services';
import {HtmlHelper} from '@app/shared/helpers';

@Component({
  selector: 'app-group-filter',
  templateUrl: './group-filter.component.html',
  styleUrls: ['./group-filter.component.scss']
})
export class GroupFilterComponent implements OnInit {
  @Input() tabIndex = 0;
  @Output() countChange = new EventEmitter<number>();
  isMobile: boolean;
  windowWidth: number = window.innerWidth;
  mobileListToggleStatus: boolean;
  isLogged: boolean;
  selectedName: string;
  allowResetMenu;
  @Output() groupFilterCheck = new EventEmitter<string>();
  listGroup = ['Все рецепты', 'Избранное', 'Было в меню', 'Мои рецепты'];

  constructor(
      private router: Router,
      private recipeService: RecipeService,
      private accountService: AccountService,
      private landingService: LandingService,
      private changeFiltersService: ChangeFiltersService
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
  }

  ngOnInit() {
    this.recipeService.getFilterState().subscribe(state => {
      if (state) {
        this.tabIndex = 0;
        this.groupFilterCheck.emit('');
      }
    });

    this.accountService.isAuthenticated().then(result => {
      this.isLogged = (result.isLoggedIn && !result.isAnonymous);
    });

    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);

    this.changeFiltersService.getAllowResetRecipes().subscribe(x => {
      this.allowResetMenu = x;
    });

    this.changeFiltersService.getStateReadyMenu().subscribe(x => {
      if (this.allowResetMenu && !this.isMobile) {
        this.resetSelected(true);
      }
    });
  }

  onIndexClick(index, cancelRedirect?: boolean) {
    const checkRedirect = this.checkCurrentLocation();
    if (!(this.tabIndex === index)) {
      this.tabIndex = index;
      this.countChange.emit(this.tabIndex);

      this.clearFilters();

      let filterName = '';
      switch (index) {
        case 0:
          break;
        case 1:
          filterName = 'IsFavorite';
          break;
        case 2:
          filterName = 'IsUsed';
          break;
        case 3:
          filterName = 'IsPersonal';
          break;
      }
      if (filterName) {
        this.recipeService.setFilter(filterName, '1');
      }

      this.selectedName = this.listGroup[index];
      this.recipeService.setSearchStatus(true);
      this.groupFilterCheck.emit(filterName);

      if (!this.isMobile) {
        this.recipeService.get();
        this.recipeService.getShort();
      }
    }
    if (checkRedirect && !cancelRedirect) {
      this.router.navigateByUrl('/main/recipes/list');
    }
  }

  checkCurrentLocation(): boolean {
    // TODO: Переделать на indexOf, повторяется во всех фильтрах, следует вынести в хэлпер
    const wayForCheck = window.location.href;
    let firstPosition = (wayForCheck.length - 8);
    let stringForCheck = wayForCheck.substring(firstPosition, wayForCheck.length);
    if (stringForCheck === 'planning') {
      return false;
    }

    firstPosition = (wayForCheck.length - 7);
    stringForCheck = wayForCheck.substring(firstPosition, wayForCheck.length);
    if (stringForCheck === 'recipes') {
      return false;
    }

    firstPosition = (wayForCheck.length - 12);
    stringForCheck = wayForCheck.substring(firstPosition, wayForCheck.length);
    return stringForCheck !== 'recipes-edit';
  }

  clearFilters() {
    this.recipeService.setFilter('IsFavorite', undefined);
    this.recipeService.setFilter('IsPersonal', undefined);
    this.recipeService.setFilter('IsUsed', undefined);
  }

  mobileListToggle() {
    if (this.isMobile && this.isLogged) {
      this.mobileListToggleStatus = !this.mobileListToggleStatus;
    }
  }

  callAuthorization() {
    this.landingService.toggleSignupDialog(false);
    this.landingService.toggleLoginDialog(false);
    this.landingService.toggleAuthorizationDialog(true);
  }

  mobileListClose() {
    this.mobileListToggleStatus = false;
  }

  resetSelected(cancelRedirect?: boolean) {
    this.onIndexClick(0, cancelRedirect);
  }

}



// WEBPACK FOOTER //
// ./src/app/group-filter/group-filter.component.ts